import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_BIWEEKLY_PERIODS } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError, notifySuccess } from '@/lib/notifications'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const biweeklyPeriods = {
  namespaced: true,
  state: buildInitialState({
    biweeklyPeriodsList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setBiweeklyPeriods: (state, biweeklyPeriods) => {
      state.biweeklyPeriodsList = biweeklyPeriods
    }
  },
  actions: {
    getBiweeklyPeriods: ({ commit, dispatch }, year = new Date().getFullYear()) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting periods, please wait...' })

      return api.doGet({ path: PATH_BIWEEKLY_PERIODS, parameters: { year: year } })
        .then(json => json.data)
        .then(biweeklyPeriods => {
          commit('updateStatus', { status: COMPLETE })
          commit('setBiweeklyPeriods', biweeklyPeriods)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get periods')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    savePeriods ({ commit, dispatch }, periods) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving periods, please wait...' })
      return api.doPost({ path: PATH_BIWEEKLY_PERIODS, data: periods })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to save periods')
          }

          notifySuccess(dispatch, 'Periods saved')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to save periods')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default biweeklyPeriods
